import React from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const KofiLinkButton = ({onClick = () => {}}) => {
  const theme = useTheme();
  const navigate = useNavigate()

  const handleClick = () => {
    navigate('/support')
    onClick()
  }

  return (
    <Tooltip title='support us!'>
      <IconButton onClick={handleClick}>
        {React.cloneElement(<VolunteerActivismIcon/>, { sx: { color: theme.palette.accent.main } })}
      </IconButton>
    </Tooltip>
  );
};

export default KofiLinkButton;